import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const activityApi = {
  getActivityInfo(gameId) {
    return http.get(API_URLS.ACTIVITY_COMPETITION_INFO, {
      query: {gameId},
    });
  },
  getTeamDetail(gameId, teamId) {
    return http.get(API_URLS.ACTIVITY_COMPETITION_TEAM_DETAIL, {
      query: {gameId, teamId, scene: 'COMPETITION', channel: 'PC'},
    });
  },
  getTeamMembers(query) {
    return http.get(API_URLS.ACTIVITY_COMPETITION_INDIVIDUAL_RANK, {
      query: {
        group: 'G_ROI',
        ...query,
      },
    });
  },
  getActivityTeamList(query) {
    return http.get(API_URLS.ACTIVITY_COMPETITION_TEAM_RANK, {
      query: {
        ...query,
        scene: 'COMPETITION',
        channel: 'PC',
      },
    });
  },
  createTeam(params) {
    return http.post(API_URLS.ACTIVITY_COMPETITION_CREATE_TEAM, {
      params: {
        ...params,
        scene: 'COMPETITION',
        channel: 'PC',
      },
    });
  },
  joinTeam(gameId, teamId) {
    return http.post(API_URLS.ACTIVITY_COMPETITION_JOIN, {
      params: {
        scene: 'COMPETITION_MEMBER_JOIN',
        channel: 'PC',
        teamId,
        gameId,
        teamFlag: true,
      },
    });
  },
  joinCompetition(gameId) {
    return http.post(API_URLS.ACTIVITY_COMPETITION_JOIN, {
      params: {
        scene: 'COMPETITION_MEMBER_JOIN',
        channel: 'PC',
        gameId,
        teamFlag: false,
      },
    });
  },
  getMyActivityPNLInfo(gameId) {
    return http.get(API_URLS.ACTIVITY_COMPETITION_SELF, {
      // rankGroup: 排序规则组，G_TRADE:trade volume, G_ROI:ROI.获得当前用户,roi 与 trade volume 的排名.
      query: {gameId, rankGroup: ['G_PNL'], needRank: true},
    });
  },
  getIndividualPNLRankList(gameId, pageIndex = 0, pageSize = 10) {
    return http.get(API_URLS.ACTIVITY_COMPETITION_INDIVIDUAL_RANK, {
      query: {gameId, group: 'G_PNL', index: pageIndex, size: pageSize},
    });
  },
  // 交易挖矿
  getTradeMiningInfo(miningCode) {
    return http.get(API_URLS.TRADE_MINING_INFO, {
      query: {miningCode},
    });
  },
  joinTradeMining(miningCode) {
    return http.post(API_URLS.TRADE_MINING_APPLY, {
      params: {miningCode},
    });
  },
  getUserJoinTradeMiningInfo(miningCode) {
    return http.get(API_URLS.TRADE_MINING_APPLY, {
      query: {miningCode},
    });
  },
  getUserTradeScoreInfo(miningCode) {
    return http.get(API_URLS.TRADE_MINING_USER_SCORE_INFO, {
      query: {miningCode},
    });
  },
  getUserTradeMissionsInfo(miningCode) {
    return http.get(API_URLS.TRADE_MINING_USER_MISSION_INFO, {
      query: {miningCode},
    });
  },
  getTradeMiningMissions(miningCode) {
    return http.get(API_URLS.TRADE_MINING_MISSION_LIST, {
      query: {miningCode},
    });
  },
  uploadTwitterSnapshot(miningCode, twitterAccount, screenshotUrl) {
    return http.post(API_URLS.TRADE_MINING_UPLOAD_TWITTER_SCREENSHOT, {
      params: {miningCode, twitterAccount, screenshotUrl},
    });
  },
  // 翻币活动
  getFlipActivityInfo(activityId) {
    return http.get(API_URLS.CLIP_COIN_ACTIVITY_INFO, {
      query: {activityId},
    });
  },
  getUserFlipActivityApplyStatus(activityId) {
    return http.get(API_URLS.CLIP_COIN_USER_ACTIVITY_APPLY_STATUS, {
      query: {activityId},
    });
  },
  applyFlipActivity({dailyActivityId, activityId, trend, multiplier}) {
    return http.post(API_URLS.CLIP_COIN_APPLY_ACTIVITY, {
      params: {dailyActivityId, activityId, applyResult: trend, applyMultiply: multiplier},
    });
  },
  getApplyFlipActivityResult(activityId, dailyActivityId) {
    return http.get(API_URLS.CLIP_COIN_APPLY_ACTIVITY_RESULT, {
      query: {activityId, dailyActivityId},
    });
  },
  getFlipActivityApplyHistory({activityId, pageNum, pageSize}) {
    return http.get(API_URLS.CLIP_COIN_ACTIVITY_APPLY_HISTORY, {
      query: {activityId, pageNum, pageSize},
    });
  },
  claimFlipActivityReward(activityId) {
    return http.post(API_URLS.CLIP_COIN_CLAIM_REWARD, {
      params: {activityId},
    });
  },
  getFlipActivityRankLogout({activityId, pageNum, pageSize, activityDate}) {
    return http.get(API_URLS.CLIP_COIN_ACTIVITY_RANK_LOGOUT, {
      query: {activityId, pageNum, pageSize, activityDate},
    });
  },
  getFlipActivityRankLogin({activityId, pageNum, pageSize, activityDate}) {
    return http.get(API_URLS.CLIP_COIN_ACTIVITY_RANK_LOGIN, {
      query: {activityId, pageNum, pageSize, activityDate},
    });
  },
  getBarragers(activityId, offset, limit) {
    return http.get(API_URLS.CLIP_COIN_GET_BARRAGERS, {
      query: {activityId, offset, limit},
    });
  },
  sendBarrager(activityId, message) {
    return http.post(API_URLS.CLIP_COIN_SEND_BARRAGER, {
      params: {activityId, message},
    });
  },
  /**
   * firebase 推送，将firebase token传给后端
   * @param deviceId，对于前端来说是firebase 给到的token
   * @param lang
   * @returns {Promise | Promise<unknown>}
   */
  updatePushDevice(deviceId, lang, bid, device) {
    return http.post(API_URLS.PUSH_DEVICE_UPDATE, {
      params: {deviceId, lang, bid, device, source: 'firebase'},
    });
  },

  // 预言家活动
  getPredictActivityInfo() {
    return http.get(API_URLS.PREDICT_ACTIVITY_INFO, {});
  },
  getUserPredictActivityBetRecords(activityId, offset, limit) {
    return http.get(API_URLS.PREDICT_ACTIVITY_USER_RECORDS, {
      query: {activityId, offset, limit},
    });
  },
  postPredictActivityUserBet({activityId, activityItemId, googleCode, priceRangeList}) {
    return http.post(API_URLS.PREDICT_ACTIVITY_BET, {
      params: {activityId, activityItemId, otpCode: googleCode, priceRangeList},
    });
  },
  getUserTodayPredictActivityBetRecords(activityItemId) {
    return http.get(API_URLS.PREDICT_ACTIVITY_USER_TODAY_RECORDS, {
      query: {activityItemId},
    });
  },
  getNotifications(offset, limit) {
    return http.get(API_URLS.PREDICT_ACTIVITY_NOTIFICATIONS, {
      query: {offset, limit},
    });
  },

  //KOL 专属活动
  getKOLExclusiveActivityInfo(activityId) {
    return http.get(API_URLS.KOL_EXCLUSIVE_ACTIVITY_INFO, {
      query: {activityId},
    });
  },
  getKOLExclusiveActivityUserInfo(activityId, referralCode) {
    return http.get(API_URLS.KOL_EXCLUSIVE_ACTIVITY_USER_INFO, {
      query: {activityId, referralCode},
    });
  },
  claimKOLExclusiveActivityBonus(activityId, referralCode) {
    return http.post(API_URLS.KOL_EXCLUSIVE_ACTIVITY_CLAIM, {
      params: {activityId, referralCode},
    });
  },

  // KOL专属落地页
  getKOLActivityConfigs(activityId, email = '') {
    return http.get(API_URLS.KOL_ACTIVITY_CONFIG, {query: {campaignId: activityId, email: email}});
  },
  getKOLActivityUserInfo(activityId) {
    return http.get(API_URLS.KOL_ACTIVITY_USER_INFO, {query: {campaignId: activityId}});
  },
  signupKOLActivity(activityId) {
    return http.post(API_URLS.KOL_ACTIVITY_SIGN_UP, {params: {campaignId: activityId}});
  },
  signupTaskActivity(activityId, email) {
    return http.post(API_URLS.KOL_ACTIVITY_SIGN_UP, {params: {campaignId: activityId, email}});
  },
  chekcKOLLandingPageExists(referralCode) {
    return http.get(API_URLS.KOL_LANDING_PAGE_EXIST, {query: {referralCode}});
  },
  getCustomizeActivityInfo(activityId) {
    return http.get(API_URLS.CUSTOMIZE_ACTIVITY_INFO, {query: {campaignId: activityId}});
  },
  postCustomizeActivitySignUp(activityId) {
    return http.post(API_URLS.CUSTOMIZE_ACTIVITY_SIGN_UP, {params: {campaignId: activityId}});
  },
  postCustomizeActivitySubscribe(activityId, email) {
    return http.post(API_URLS.CUSTOMIZE_ACTIVITY_SUBSCRBE, {params: {campaignId: activityId, email}});
  },

  // 查询用户twitter提交信息
  getUserSubmittedTwitterInfo() {
    return http.get(API_URLS.WELCOME_BONUS_MEDIA_RECORDS, {query: {media: 'TWITTER'}});
  },
  getWelcomeBonusAmount(lang) {
    return http.get(API_URLS.WELCOME_BONUS_AMOUNT, {query: {lang}});
  },

  // price page 查询货币列表
  getCoinList() {
    return http.get(API_URLS.GET_COIN_LIST, {query: {}});
  },
  updateCampaignIncrementAndGet(query) {
    return http.post(API_URLS.CAMPAIGN_INCREMENT_ANDGET, {query});
  },
  getActivityUserInfo() {
    return http.get(API_URLS.ACTIVITY_USER_INFO, {query: {}});
  },

  // 热门现货 合约
  getHotSpotsAndContracts() {
    return http.get(API_URLS.HOT_SPOT_CONTRACT, {query: {}});
  },

  // 权益中心-my rewards
  getActivityRewards(query) {
    return http.get(API_URLS.ACTIVITY_REWARDS, {query});
  },

  // xpt mining 活动
  getXPTMiningInfo() {
    return http.get(API_URLS.XPT_MINING_INFO, {query: {}});
  },
  getXPTMiningUserInfo(xptMiningActivityId) {
    return http.get(API_URLS.XPT_MINING_USER_INFO, {query: {xptMiningActivityId}});
  },
  getXPTMiningRankList(xptMiningActivityId, pageNum, pageSize) {
    return http.get(API_URLS.XPT_MINING_RANK_LIST, {query: {xptMiningActivityId, pageNum, pageSize}});
  },

  //xpt airdrop 活动
  getOperationActivityInfo(channel, scene, activityId) {
    return http.get(API_URLS.ACTIVITY_OPERATION_INFO, {query: {channel, scene, activityId}});
  },
  submitActivityUserAddress({activityId, channel, scene, chainAddress, signature, encryptCode}) {
    return http.post(API_URLS.ACTIVITY_OPERATION_SUBMIT_MATERIAL, {params: {channel, activityId, scene, chainAddress, signature, encryptCode}});
  },
  getOperationActivityUserTasks(channel, scene, activityId) {
    return http.get(API_URLS.ACTIVITY_OPERATION_USER_TASK_LIST, {query: {channel, scene, activityId}});
  },
  claimOperationActivityRewards({channel, scene, activityId, qualificationId}) {
    return http.post(API_URLS.ACTIVITY_CLAIM_PRIZE, {params: {channel, scene, activityId, qualificationId}});
  },
  getOperationActivityRewardsStatus(channel, scene, activityId) {
    return http.get(API_URLS.CT_ACTIVITY_PRIVILEGE_LIST, {query: {channel, scene, activityId}});
  },
  getActivityScrollParticipants(channel, scene, activityId) {
    return http.get(API_URLS.ACTIVITY_SCROLL_PARTICIPANT, {query: {channel, scene, activityId}});
  },
  getActivityPrizePool(channel, scene, activityId) {
    return http.get(API_URLS.ACTIVITY_QUERY_PRIZE_POOL, {query: {channel, scene, activityId}});
  },
  getActivityPrizePoolLogin(channel, scene, activityId) {
    return http.get(API_URLS.ACTIVITY_QUERY_PRIZE_POOL_LOGIN, {query: {channel, scene, activityId}});
  },
  xPTAirdropGray(channel, scene) {
    return http.get(API_URLS.ACTIVITY_XPT_AIRDROP_GARY, {query: {channel, scene}});
  },
  //space id
  submitWalletAddressForSpaceId(channel, scene, activityId, walletAddress) {
    return http.post(API_URLS.SPACE_ID_SUBMIT_WALLET_ADDRESS, {params: {channel, scene, activityId, walletAddress}});
  },
  claimSpaceIdGiftCard(channel, scene, activityId, taskId) {
    return http.post(API_URLS.SPACE_ID_CLAIM_GIFTCARD, {params: {channel, scene, activityId, taskId}});
  },
  checkSpaceIdWalletAddress(channel, scene, activityId) {
    return http.get(API_URLS.SPACE_ID_CHECK_WALLET_ADDRESS, {query: {channel, scene, activityId}});
  },
  checkSpaceIdGiftCardStatus(channel, scene, activityId, taskId) {
    return http.get(API_URLS.SPACE_ID_CHECK_CLAIM_STATUS, {query: {channel, scene, activityId, taskId}});
  },
  getChainSpaceIdGiftCardCount(channel, scene, activityId) {
    return http.get(API_URLS.SPACE_ID_GIFTCARD_COUNT, {query: {channel, scene, activityId}});
  },
  getPublicChainSpaceIdGiftCardCount(channel, scene, activityId) {
    return http.get(API_URLS.SPACE_ID_PUBLIC_GIFTCARD_COUNT, {query: {channel, scene, activityId}});
  },
  // 活动灰度
  getActivityGrayInfo(channel, scene) {
    return http.get(API_URLS.ACTIVITY_GARY, {query: {channel, scene}});
  },
  // 邀请页面总信息
  getReferralTotalInfo(channel, scene) {
    return http.get(API_URLS.ACTIVITY_REFERRAL_TOTAL_INFO, {query: {channel, scene}});
  },
  // 邀请页面信息
  getReferralInfo({stageKey, channel, scene, index, size}) {
    return http.get(API_URLS.ACTIVITY_REFERRAL_INFO, {query: {stageKey, channel, scene, index, size}});
  },
  // 查询用户自己的类型
  getUserReferralType(channel, scene) {
    return http.get(API_URLS.ACTIVITY_REFERRAL_SELF_USER_TYPE, {query: {channel, scene}});
  },
  // 查询各个stage referral 奖励
  getReferralStageRewards(channel, scene) {
    return http.get(API_URLS.ACTIVITY_REFERRAL_STAGE_REWARDS, {query: {channel, scene}});
  },
  getTradingContestInfo(query) {
    return http.get(API_URLS.FUTURE_GRIDS_CONTEST_INFO, {query});
  },
  getTradingContestUserInfo(query) {
    return http.get(API_URLS.FUTURE_GRIDS_CONTEST_USER_INFO, {
      query: {...query, needRank: true},
    });
  },
  getTradingContestRanking(query) {
    return http.get(API_URLS.FUTURE_GRIDS_CONTEST_RANKING, {query});
  },
  getTradingContestAward(query) {
    return http.get(API_URLS.FUTURE_GRIDS_CONTEST_AWARD, {query});
  },
  getTradingContestSummary(query) {
    return http.get(API_URLS.FUTURE_GRIDS_CONTEST_SUMMARY, {query});
  },
  getTradingContestTask(query) {
    return http.get(API_URLS.FUTURE_GRIDS_CONTEST_TASK, {query});
  },
  getEmailInfo(query) {
    return http.get(API_URLS.EMAIL_CONFIRM, {query});
  },
  emailUnsubscribes(params) {
    return http.post(API_URLS.EMAIL_UNSUBSCRIBE, {params});
  },
  emailSubscribes(params) {
    return http.post(API_URLS.EMAIL_SUBSCRIBE, {params});
  },
  // PT 挖矿
  getPTMiningPool() {
    return http.get(API_URLS.WEB3_PT_MINING_PUBLIC_MINING_POOL, {query: {}});
  },
  getPTMiningUserAwardHistory(pageNum, pageSize) {
    return http.get(API_URLS.PT_MINING_USER_AWARD_HISTORY, {query: {pageNum, pageSize}});
  },
  queryPTMiningUserAward(activityTime) {
    return http.get(API_URLS.WEB3_PT_MINING_AWARD_RECORD, {query: {activityTime}});
  },
  getPTMiningUserInfo() {
    return http.get(API_URLS.WEB3_PT_MINING_MINING_USER, {query: {}});
  },
  getPTMiningUserBoost() {
    return http.get(API_URLS.WEB3_PT_MINING_AWARD_BOOST, {query: {}});
  },
  updatePTMiningUserAwardType(ptAwardType) {
    return http.put(API_URLS.WEB3_PT_MINING_AWARD_TYPE_UPDATE, {params: {ptAwardType}});
  },
  getPTMiningUserStatistic(month) {
    return http.get(API_URLS.WEB3_PT_MINING_MONTH_STATISTIC, {query: {month}});
  },
  calcPTMiningAwardBoost({feeRv, assetRv, vePtVolumeRv, platformPtVolumeRv}) {
    return http.post(API_URLS.WEB3_PT_MINING_AWARD_BOOST_CALCULATE, {params: {feeRv, assetRv, vePtVolumeRv, platformPtVolumeRv}});
  },
  getActivityDetail(query) {
    return http.get(API_URLS.ACTIVITY_DETAIL, {query});
  },
  postActivityApply(params) {
    return http.post(API_URLS.ACTIVITY_APPLY, {params});
  },
  getActivityChristmasUserInfo(query) {
    return http.get(API_URLS.ACTIVITY_CHRISTMAS_USER_INFO, {query});
  },

  // 交易大赛模块化
  getMyActivityInfo(gameId, groupType) {
    return http.get(API_URLS.ACTIVITY_COMPETITION_SELF, {
      // rankGroup: 排序规则组，G_TRADE:trade volume, G_ROI:ROI.获得当前用户,roi 与 trade volume 的排名.
      query: {gameId, rankGroup: [groupType], needRank: true},
    });
  },
  getIndividualRankList(gameId, groupType, pageIndex = 0, pageSize = 10) {
    return http.get(API_URLS.ACTIVITY_COMPETITION_INDIVIDUAL_RANK, {
      query: {gameId, group: groupType, index: pageIndex, size: pageSize},
    });
  },

  // price page 详情
  getCurrencyRate(currency, base, scale = 6) {
    return http.get(API_URLS.GET_CURRENCY_EXCHANGE_RATE, {query: {baseCurrency: base, contraCurrency: currency, scale}});
  },
  getFiatList() {
    return http.get(API_URLS.GET_FIAT_LIST, {query: {}});
  },
  getCoinAbout({currency, lang}) {
    return http.get(API_URLS.GET_COIN_ABOUT, {query: {currency, lang}});
  },
  uploadImage(formData) {
    return http.upload(API_URLS.IM_UPLOAD_IMAGE, {formData});
  },

  //KOL 专属活动
  getKolExclusiveActivityInfo(referralCode) {
    return http.get(API_URLS.EXCLUSIVE_ACTIVITY_INFO, {
      query: {
        bizCode: referralCode,
        activityRule: 1004,
      },
    });
  },
  getUserKolExclusiveActivityInfo() {
    return http.get(API_URLS.USER_EXCLUSIVE_ACTIVITY_INFO, {
      query: {
        activityRule: 1004,
      },
    });
  },
  claimUserKolExclusiveActivity(referralCode, activityId) {
    return http.post(API_URLS.USER_CLAIM_EXCLUSIVE_ACTIVITY, {
      params: {
        bizCode: referralCode,
        activityRule: 1004,
        activityId,
      },
    });
  },

  // 奖池列表
  getPrizeList(id) {
    return http.get(API_URLS.PRIZE_POOL_LIST, {
      query: {
        channel: 'ADMIN',
        scene: 'TASK',
        groupType: 'POOL',
        activityId: id,
      },
    });
  },

  // 开始抽奖
  startLottery(id, qualificationId) {
    return http.post(API_URLS.LOTTERY_BY_QUALIFICATIONID, {
      params: {
        channel: 'ADMIN',
        activityId: id,
        qualificationId,
        scene: 'TASK',
      },
    });
  },
  // 获取弹幕列表
  getScrollPrivilegeList(id) {
    return http.get(API_URLS.SCROLL_PRIVILEGE, {
      query: {
        channel: 'ADMIN',
        activityId: id,
        scene: 'TASK',
      },
    });
  },

  // 获取分页查询的奖励列表
  getRewardsList(id) {
    return http.get(API_URLS.REWARDS_LIST, {
      query: {
        channel: 'ADMIN',
        activityId: id,
        scene: 'TASK',
        privilegeType: 'BLACK_PRIZE',
      },
    });
  },
  // 任务列表
  getTaskList(id) {
    return http.get(API_URLS.TASK_LIST, {
      query: {
        channel: 'ADMIN',
        scene: 'TASK',
        activityId: id,
      },
    });
  },
  // 邀请列表
  getReferralList(id, taskId, pageNum, limit) {
    return http.get(API_URLS.INVITE_LIST, {
      query: {
        campaignId: id,
        taskId,
        pageNum,
        channel: 'WEB',
        scene: 'ADMIN',
        pageSize: limit,
      },
    });
  },
  // 查看抽奖详情
  getLotteryDetail(ids) {
    return http.get(API_URLS.LOTTERY_DETAIL, {
      query: {
        channel: 'ADMIN',
        scene: 'TASK',
        list: ids,
      },
    });
  },

  // 团赛
  getTeamActivityInfo(query) {
    return http.get(API_URLS.TEAM_COMPETITION_INFO, {query});
  },
  getMyInfo(query){
    return http.get(API_URLS.TEAM_COMPETITION_USER_INFO, {query})
  },
  getTeamInfo(query){
    return http.get(API_URLS.TEAM_COMPETITION_TEAM_INFO, {query})
  },
  leaveTeam(params){
    return http.post(API_URLS.TEAM_COMPETITION_LEAVE_TEAM, {params})
  },
  manageTeam(params){
    return http.post(API_URLS.TEAM_COMPETITION_MANAGE_TEAM, {params})
  },
  getMyRewards(query){
    return http.get(API_URLS.TEAM_COMPETITION_INFO, {query})
  },
  getTopTeams(query){
    return http.get(API_URLS.TEAM_COMPETITION_TEAMS, {query})
  },
  getTopTeamsLogin(query){
    return http.get(API_URLS.TEAM_COMPETITION_TEAMS_LOGIN, {query})
  },
  getTeamMembersLogin(query){
    return http.get(API_URLS.TEAM_COMPETITION_RANKING_LOGIN, {query})
  },
  createMyTeam(params){
    return http.post(API_URLS.TEAM_COMPETITION_CREATE_TEAM, {params})
  },
  getIndividualRanks(query){
    return http.get(API_URLS.TEAM_COMPETITION_INDIVIDUAL_RANKS, {query})
  },
  joinTeamCompetition(params){
    return http.post(API_URLS.TEAM_COMPETITION_JOIN, {params})
  },
  getUserNetAsset(query){
    return http.get(API_URLS.TEAM_COMPETITION_USE_NET_ASSET, {query})
  }
};
